/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/295-volume-high': {
    width: 17,
    height: 16,
    viewBox: '0 0 17 16',
    data: '<path pid="0" d="M13.907 14.407a.75.75 0 01-.53-1.281c1.369-1.369 2.123-3.19 2.123-5.127s-.754-3.757-2.123-5.127a.75.75 0 111.061-1.061c1.653 1.653 2.563 3.85 2.563 6.187s-.91 4.534-2.563 6.187a.748.748 0 01-.53.22zm-2.664-1.414a.75.75 0 01-.53-1.281 5.256 5.256 0 000-7.425.75.75 0 111.061-1.061c1.275 1.275 1.977 2.97 1.977 4.773s-.702 3.498-1.977 4.773a.748.748 0 01-.53.22zm-2.665-1.415a.75.75 0 01-.53-1.281 3.254 3.254 0 000-4.596.75.75 0 111.061-1.061 4.756 4.756 0 010 6.718.748.748 0 01-.53.22zM6.5 15a.504.504 0 01-.354-.146L2.292 11H.499a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5h1.793l3.854-3.854A.499.499 0 017 1.5v13a.5.5 0 01-.5.5z"/>'
  }
})
